import apiClient from 'api/apiConfig';

export const stopJob = async (jobId: number): Promise<void> => {
  await apiClient.post(`csb/jobs/${jobId}/stop`);
};

export const resubmitJob = async (jobId: number): Promise<void> => {
  await apiClient.post(`csb/jobs/${jobId}/resubmit`);
};
